//ng build --dev --no-sourcemap --output-hashing=all
//--output-hashing=none|all|media|bundles
export class AppSettings {
    //DESARROLLO
    //public static URL = 'http://localhost:3034/api/';
    //PRE-PRODUCCION
    //public static URL = 'http://10.107.0.253:2019/api/';
    //CAPACITACION
    //public static URL = 'http://192.168.2.250:2019/api/';
    //PRODUCCION
    public static URL = './api/';
    //SIMULAR CON PRODUCCION
    //public static URL = 'http://intranet.trilce.edu.pe/api/';

    public static STORAGE_NAME = 'tyYTytTY354543HGrt.user';
    public static TOKEN = 'tyYTytTY354543HGrt.TOKEN';

    public static API_LOGIN = 'Academico/Intranet/Autenticar';
    public static API_CHANGE_PASSWORD = 'Academico/Intranet/CambiarContrasenia';
    public static API_OLVIDO_CONTRASENIA = 'Academico/Intranet/OlvidoContrasenia';
    public static API_CODIGO_CONTRASENIA = 'Academico/Intranet/CodigoContrasenia';

    public static API_INTRANET_GET_LOCALES = 'Academico/Intranet/GetListaDocenteEdificioElegido';
    public static API_GENERIC_SAVE_LOCALES = 'Academico/Intranet/GuardaDocenteConfirmacion';

    public static API_INTRANET_LISTA_GENERIC_LIST = 'Academico/Intranet/GetListaPeriodoHorario';
    public static API_INTRANET_LISTA_PERIODO_HORARIO = 'Academico/Intranet/GetListaPeriodoHorarioDocente';
    public static API_INTRANET_LISTA_DISPONIBILIDAD_DOCENTE = 'Academico/Intranet/GetListaDisponibilidadDocente';
    public static API_INTRANET_SAVE_DISPONIBILIDAD_DOCENTE = 'Academico/Intranet/GuardaDisponibilidadDocente';

    public static API_INTRANET_LISTA_ALUMNOS = 'Academico/Intranet/GetListaAlumnosIntranet';
    public static API_INTRANET_LISTA_ALUMNOS_ACARGO_DOCENTE = 'Academico/Intranet/ListaAlumnosAcargoDocente';
    public static API_INTRANET_LISTA_ALUMNOS_ACARGO_TUTOR = 'Academico/Intranet/ListaAlumnosAcargoTutor';
    public static API_INTRANET_LISTA_MENSAJE = 'Academico/Intranet/ListaMensaje';
    public static API_INTRANET_ENVIA_MENSAJE = 'Academico/Intranet/EnviaMensaje';
    public static API_INTRANET_LISTA_HORARIO = 'Academico/Intranet/ListaHorarioDocente';
    public static API_LISTA_CURSOS_CRITERIOS_NOTAS = 'Academico/Intranet/ListaCursosCriteriosNotas';
    public static API_LISTA_CURSOS_CRITERIOS_NOTAS_TUTOR = 'Academico/Intranet/ListaCursosCriteriosNotasTutor';
    public static API_LISTA_NCURSOS_CRITERIOS_NOTAS = 'Academico/Intranet/ListaNCursosCriteriosNotas';
    public static API_LISTA_NCURSOS_CRITERIOS_NOTAS_TUTOR = 'Academico/Intranet/ListaNCursosCriteriosNotasTutor';
    public static API_INTRANET_LISTA_ALUMNOS_NOTAS = 'Academico/Intranet/ListaAlumnosNotasDocente';
    public static API_INTRANET_LISTA_ALUMNOS_NOTAS_TUTOR = 'Academico/Intranet/ListaAlumnosNotasTutor';
    public static API_INTRANET_NLISTA_ALUMNOS_NOTAS = 'Academico/Intranet/ListaNAlumnosNotasDocente';
    public static API_INTRANET_NLISTA_ALUMNOS_NOTAS_TUTOR = 'Academico/Intranet/ListaNAlumnosNotasTutor';
    public static API_INTRANET_GUARDA_ALUMNOS_NOTAS = 'Academico/Intranet/GuardaNotasAlumnoDocente';
    public static API_INTRANET_GUARDA_ALUMNOS_NOTAS_TUTOR = 'Academico/Intranet/GuardaNotasAlumnoTutor';
    public static API_INTRANET_NGUARDA_ALUMNOS_NOTAS = 'Academico/Intranet/GuardaNNotasAlumnoDocente';
    public static API_INTRANET_NGUARDA_ALUMNOS_NOTAS_TUTOR = 'Academico/Intranet/GuardaNNotasAlumnoTutor';
    public static API_INTRANET_GRABA_ARCHIVO = 'General/File/Uploadsm';
    public static API_INTRANET_LISTA_MENSAJE_COUNT = 'Academico/Intranet/ListaMensajeCount';
    public static API_INTRANET_LISTA_BIMESTRE = 'Academico/Intranet/GetListaBimestre';
}



// WEBPACK FOOTER //
// C:/Users/egila/Downloads/temp/20260608_NuevoSAT/Trilce.Presentacion.Intranet.Profesores.NG5/src/app/support/services/app-settings.ts